/**
 * @file SpanARow.js
 * @module src/js/components/SpanARow
 * @description
 * **A table row component that spans a specified number of columns.**
 * - Can display clickable content with hover effects.
 * - Adapts styling based on the current theme (light/dark).
 *
 * @version
 * <p>
 *  2025-11-29: First version with documentation. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 *  2025-12-02: Added loading state support. (Zong-Han Wu, zhwu@eda.ee.ntu.edu.tw)<br/>
 * </p>
 */
import { useState } from 'react';
import { useTheme } from '../contexts/ThemeProvider';
import { X } from 'lucide-react';
import { LoadingThreeDots } from './UtilityComponents';

export default function SpanARow({
    colSpan,
    onClick,
    text,
    icon,
    loading = false
}) {
    const { theme } = useTheme();
    const [isHovered, setIsHovered] = useState(false);
    const iconToShow = icon || <X size={30} color={theme === 'dark' ? 'lightcoral' : 'red'} />;

    return (
        <tr className='hori-vert-center'>
            <td colSpan={colSpan} width='95%'>
                {onClick != null ? (
                    <div
                        onClick={onClick}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                        style={{
                            padding: '20px',
                            border: isHovered ? '2px dashed #aaa' : `2px dashed ${theme === 'dark' ? '#888' : '#ccc'}`,
                            backgroundColor: isHovered ? (theme === 'dark' ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)')
                                : 'transparent',
                            borderRadius: '20px',
                            cursor: 'pointer',
                            fontSize: '1.2em',
                            transition: 'all 0.2s ease-in-out'
                        }}
                    >{text}</div>
                ) : loading ? <LoadingThreeDots /> : (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '5px',
                        }}
                    >
                        {iconToShow} {text}
                    </div>
                )}
            </td>
        </tr>
    )
}